<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>{{ '+SRC_COMMISSIONINGV2.ADD_COMPONENT_HEADER' | translate }}</span>
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content overflowShadow>
    <div class="content">
      <div class="content-img">
        <img
          class="flex-1"
          src="./assets/img/commissioningv2/device-black-{{
            (commissioningService.selectedDevice$ | async).icon
          }}.png"
          alt=""
        />
      </div>

      <div class="content-description">
        <div class="description-header">
          {{ '+SRC_COMMISSIONINGV2.SELECT_VENTILATION_SUBTITLE' | translate }}
        </div>

        <span class="description-channelwrapper" [ngSwitch]="assignVentilationStateLoadingState">
          <ng-container *ngSwitchCase="AssignVentilationState.AssignVentilation">
            <ng-container *ngIf="allVentilations.length; else noVentilation">
              <div class="description-section__channels" #overflowShadowObservedElement>
                <mat-radio-group
                  class="ventilation-selection__radio-group"
                  [ngModel]="selectedOption"
                  (ngModelChange)="onVentilationOptionSelect($event)"
                >
                  <mat-radio-button
                    *ngFor="let ventilation of allVentilations"
                    color="primary"
                    [value]="ventilation"
                  >
                    <span class="radio__name"
                      >{{ '+INSTALLATIONS.INSTALLATION.PANEL.VIAIR' | translate
                      }}{{ ventilation.deviceId }}</span
                    >
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </ng-container>
            <ng-template #noVentilation>
              <app-banner type="warning">
                {{ '+SRC_COMMISSIONINGV2.ASSIGN_VENTILATION_NO_VENTILATIONS' | translate }}
              </app-banner>
            </ng-template>
          </ng-container>

          <ng-container *ngSwitchCase="AssignVentilationState.Loading">
            <app-banner type="info">
              {{ '+SRC_COMMISSIONINGV2.ASSIGN_VENTILATION_LOADING_VENTILATIONS' | translate }}
            </app-banner>
          </ng-container>

          <ng-container *ngSwitchCase="AssignVentilationState.ErrorNoVentilations">
            <app-banner type="warning">
              {{ '+SRC_COMMISSIONINGV2.ASSIGN_VENTILATION_NO_VENTILATIONS' | translate }}
            </app-banner>
          </ng-container>
        </span>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <button
      gtm="onPreviousStep"
      gtmAction="Previous step"
      gtmCategory="assignVentilationModal"
      mat-stroked-button
      color="primary"
      (click)="navigateBack()"
    >
      {{ 'GENERAL.BUTTON.BACK' | translate }}
    </button>
    <button
      gtm="onNextStep"
      gtmAction="Next step"
      gtmCategory="assignVentilationModal"
      mat-raised-button
      color="primary"
      (click)="navigateForward()"
    >
      {{ 'GENERAL.BUTTON.CONFIRM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
